import ko from 'knockout';
import _ from 'underscore';
import $ from 'jquery';
import { BidLandscapeBaseViewModel } from '../base-viewmodel';
import { BID_MODE, SYMBOL_PERCENT, TARGET_VALUE_MAP, DESC_MAP, TARGET_TITLE_MAP, INPUTPLACEHOLDER_MAP, ADDBUDGET_DESC_MAP } from './bid-mode';

const fractionDigits = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

export class CampaignBidLandscapeViewModel extends BidLandscapeBaseViewModel {
  constructor({
    parentItem,
    parentView,
    i18n,
    entityType,
    inSimpleMode,
    dataToShow,
  }) {
    super({
      parentItem, parentView, entityType, i18n, inSimpleMode, dataToShow,
    });
    this.cpcSymbol = ko.observable(SYMBOL_PERCENT.INCREASE);
    this.disabledBid = !dataToShow[BID_MODE.CAMPAIGN_WIDE_BID] || false;
    this.disabledCPC = !dataToShow[BID_MODE.BID_SCALING] || false;
    this.campaignSelectMode = ko.observable(dataToShow[BID_MODE.BID_SCALING] ?
      BID_MODE.BID_SCALING :
      (_.filter(_.values(BID_MODE), key => !!dataToShow[key])[0] || BID_MODE.CAMPAIGN_WIDE_BID));
    this.hash = ko.computed(() => {
      if (dataToShow[this.campaignSelectMode()]) {
        return dataToShow[this.campaignSelectMode()].Hash;
      }
      return '';
    });
    this.showBid = ko.computed(() => this.campaignSelectMode() !== BID_MODE.BID_SCALING);
    this.showCPC = ko.computed(() => this.campaignSelectMode() === BID_MODE.BID_SCALING);
    this.showCurrencySymbol = ko.computed(() => this.campaignSelectMode() !== BID_MODE.TARGET_ROAS);
    this.showAdditionalBudgetPanel = ko.observable(false);
    this.keepCurrentBudget = ko.observable(true);
    this.currentBudget = ko.observable('');
    this.currencyCode = parentItem.CurrencyCode;
    this.campaignName = parentItem.EntityName;
    this.currentTargetValue = parentItem.CurrentTargetValue;
    this.currencySymbol = ko.observable(i18n.getCurrencySymbol(this.currencyCode));
    this.needBudget = ko.observable('');
    this.additionalBuget = ko.observable('');
    this.showImpr = ko.observable(false);
    this.showImprTop = ko.observable(false);
    this.showConv = ko.observable(false);
    this.showConvValue = ko.observable(false);
    this.focusInput = ko.computed(() => this.landscapePointsLength() === this.currentSelectedId());
    this.percentOptions = [
      { text: i18n.getString('Symbol_Percent_Increase'), value: SYMBOL_PERCENT.INCREASE },
      { text: i18n.getString('Symbol_Percent_Decrease'), value: SYMBOL_PERCENT.DECREASE },
    ];
    this.descrpition = ko.computed(() => i18n.getString(DESC_MAP[this.campaignSelectMode()]));
    this.additionalBudgetDescrpition = ko.computed(() => i18n.getString(ADDBUDGET_DESC_MAP[this.campaignSelectMode()]));
    this.targetTitle = ko.computed(() => i18n.getString(TARGET_TITLE_MAP[this.campaignSelectMode()]));
    this.inputPlaceholder = ko.computed(() => i18n.getString(INPUTPLACEHOLDER_MAP[this.campaignSelectMode()]));
    this.tableBidText = ko.computed(() => {
      const mode = this.campaignSelectMode() === BID_MODE.CAMPAIGN_WIDE_BID;
      return mode ?
        i18n.getString('KPI_Campaign_Bid') :
        i18n.getString('KPI_Campaign_MarginalCPC');
    });

    this.increseBudgetText = ko.computed({
      read: () => i18n.getString('Campaign_BidLandscape_AdditionalBudget_Increase')
        .replace('{0}', `${this.currentBudget()}`)
        .replace('{1}', `${this.needBudget()}`),
    });

    this.footerText = ko.computed({
      read: () => i18n.getString('Campaign_BidlandscapeHelpText')
        .replace('{0}', `<b>${this.startDateString()}</b>`)
        .replace('{1}', `<b>${this.endDateString()}</b>`),
    });

    this.currentSelectedColomn = ko.observable('clicks');

    this.updatedSelectedColumn = (event) => {
      const colName = $(event.target).data('name');
      if (colName) {
        this.currentSelectedColomn(colName);
      }
      return true;
    };

    this.campaignSelectMode.subscribe(() => {
      this.userInput('');
      this.cpcSymbol(SYMBOL_PERCENT.INCREASE);
      this.currentSelectedId(-1);
      this.convertDataForBidLandscape();
    });

    this.currentSelectedId.subscribe((newValue) => {
      const item = this.dataArray()[newValue];
      if (item && item.additionalBugetNeeds > 0) {
        this.showAdditionalBudgetPanel(true);
        this.keepCurrentBudget(false);
        this.currentBudget(i18n.formatCurrency(
          item.currentBudget,
          this.currencyCode,
          fractionDigits
        ));
        this.additionalBuget(item.currentBudget + item.additionalBugetNeeds);
        this.needBudget(i18n.formatCurrency(
          item.currentBudget + item.additionalBugetNeeds,
          this.currencyCode,
          fractionDigits
        ));
      } else {
        this.showAdditionalBudgetPanel(false);
        this.keepCurrentBudget(true);
      }
    });

    this.selectedValueUpdated = () => {
      this.inputErrorMessage('');
      if (this.currentSelectedId() === this.landscapePointsLength()) {
        let value = this.userInput();
        if (_.isEmpty(value) || !i18n.isValidDecimal(value, true)) {
          this.inputErrorMessage(i18n.getString('ErrorMessage_InputNumericValue'));
        } else if (i18n.parseDecimal(value) <= 0) {
          this.inputErrorMessage(i18n.getString('InputValueGreaterThanZero'));
        } else {
          value = i18n.parseDecimal(value);
          if (this.campaignSelectMode() === BID_MODE.BID_SCALING) {
            value = this.cpcSymbol() === SYMBOL_PERCENT.INCREASE ? value : -value;
          } else if (this.campaignSelectMode() === BID_MODE.TARGET_ROAS) {
            value /= 100;
          }
          this.valueToApply(value);
        }
      } else if (this.currentSelectedId() >= 0) {
        this.valueToApply(this.dataArray()[this.currentSelectedId()].bid);
      }
    };

    this.formatDateObj = obj => `${obj.Month}/${obj.Day}/${obj.Year}`;

    this.convertDataForBidLandscape = () => {
      if (!_.isEmpty(dataToShow) && !dataToShow.Nodata) {
        const dataType = dataToShow[this.campaignSelectMode()];
        const data = this.convertDataForChart(dataType);

        if (this.campaignSelectMode() === BID_MODE.TARGET_CPA) {
          this.currentSelectedColomn('conversion');
        } else if (this.campaignSelectMode() === BID_MODE.TARGET_ROAS) {
          this.currentSelectedColomn(data.showConvValue ? 'conversionValue' : 'conversion');
        } else if (!data.showClick) {
          this.currentSelectedColomn('impressions');
        }
        this.isClickGraph(data.showClick);
        this.showImpr(data.showImpr);
        this.showImprTop(data.showImprTop);
        this.showConv(data.showConv);
        this.showConvValue(data.showConvValue);
        this.dataArray(data.dataArray);
        if (this.currentSelectedId() === -1) {
          this.currentSelectedId(data.selectedIndex);
        }
        this.startDateString(this.formatDateObj(dataType.StartDate));
        this.endDateString(this.formatDateObj(dataType.EndDate));
      }
    };

    this.convertDataForChart = (data) => {
      let landscapePoints = [];
      let selectedIndex = -1;
      let showClick = false;
      let showImpr = false;
      let showImprTop = false;
      let showConv = false;
      let showConvValue = false;

      if (!_.isEmpty(data) && !_.isEmpty(data.BidLandscapePoints)) {
        const hasClick = this.campaignSelectMode() !== BID_MODE.TARGET_CPA;
        const hasImpressions = this.campaignSelectMode() !== BID_MODE.TARGET_CPA;
        const hasImpressionsTop = this.campaignSelectMode() !== BID_MODE.TARGET_CPA;
        const hasConversionValue = this.campaignSelectMode() === BID_MODE.TARGET_ROAS;
        const bidlandscapePoints = data.BidLandscapePoints;
        const target = TARGET_VALUE_MAP[this.campaignSelectMode()];
        landscapePoints = _.chain(bidlandscapePoints)
          .sortBy(point => -point[target])
          .uniq(point => point[target])
          .map((point, id) => {
            let bid = '';
            if (this.campaignSelectMode() === BID_MODE.CAMPAIGN_WIDE_BID || this.campaignSelectMode() === BID_MODE.TARGET_CPA) {
              bid = i18n.formatCurrency(point[target], this.currencyCode, fractionDigits);
            } else if (this.campaignSelectMode() === BID_MODE.TARGET_ROAS) {
              bid = `${i18n.formatDecimalToFixed(point[target] * 100)}%`;
            } else {
              const cpcSymbol = point[target] >= 0 ? '+' : '';
              bid = `${cpcSymbol}${i18n.formatDecimalToFixed(point[target] || 0)}%`;
            }
            const result = {
              impressions: point.Impressions || 0,
              impressionsStr: i18n.formatDecimalToInteger(point.Impressions || 0),
              mlImpressions: point.MLImpressions || 0,
              mlImpressionsStr: i18n.formatDecimalToInteger(point.MLImpressions || 0),
              bid: point[target],
              bidStr: bid,
              comment: '',
              index: id,
              clicks: point.Clicks || 0,
              clicksStr: i18n.formatDecimalToInteger(point.Clicks || 0),
              cost: point.Cost || 0,
              costStr: i18n.formatCurrency(point.Cost, this.currencyCode, fractionDigits),
              conversion: point.Conversion || 0,
              conversionStr: i18n.formatDecimalToInteger(point.Conversion || 0),
              conversionValue: point.ConversionValue || 0,
              conversionValueStr: i18n.formatDecimalToInteger(point.ConversionValue || 0),
              additionalBugetNeeds: point.AdditionalBugetNeeds || 0,
              additionalBugetNeedsStr: point.AdditionalBugetNeeds === null ?
                '-' :
                i18n.formatCurrency(point.AdditionalBugetNeeds, this.currencyCode, fractionDigits),
              currency: point.Currency,
              currentBudget: point.CurrentBudget,
            };

            if (this.showCPC() && point.Bid === 0) {
              selectedIndex = selectedIndex < 0 ? id : selectedIndex;
              result.comment = ` (${i18n.getString('Campaign_BidLandscape_Current')})`;
            }

            if (this.campaignSelectMode() === BID_MODE.TARGET_ROAS || this.campaignSelectMode() === BID_MODE.TARGET_CPA) {
              if (point[target] === this.currentTargetValue) {
                selectedIndex = selectedIndex < 0 ? id : selectedIndex;
                result.comment = ` (${i18n.getString('Campaign_BidLandscape_Current')})`;
              }
            }

            showClick = hasClick && point.Clicks > 0 ? true : showClick;
            showImpr = hasImpressions && point.Impressions > 0 ? true : showImpr;
            showImprTop = hasImpressionsTop && point.MLImpressions > 0 ? true : showImprTop;
            showConv = point.Conversion > 0 ? true : showConv;
            showConvValue = hasConversionValue && point.ConversionValue !== null ? true : showConvValue;
            return result;
          })
          .value();

        selectedIndex = selectedIndex < 0 && !_.isEmpty(bidlandscapePoints) ? 0 : selectedIndex;
      }
      return {
        dataArray: landscapePoints,
        selectedIndex,
        showClick,
        showImpr,
        showImprTop,
        showConv,
        showConvValue,
      };
    };
  }
}
